/**
 * Lightweight className utility
 * Combines multiple class names, filtering out falsy values
 * 
 * @param {...(string|boolean|null|undefined)} parts - Class name parts
 * @returns {string} Combined class names
 * 
 * @example
 * cn("base", isActive && "active", "container") // "base active container"
 * cn("base", false && "hidden", null, "text") // "base text"
 */
export function cn(...parts) {
  return parts.filter(Boolean).join(" ");
}
